import InstrumentIcon from "../instrument-icon";
import Big from "big.js";
import {useTranslation} from "react-i18next";
import SvgIcon from "../svg-icon";

const ReloadToast = ({amount, code}) => {

    const {t} = useTranslation()
    return (
        <div
            className="toast show"
            role="alert"
        >
            <div className="toast-header">
                <strong className="me-auto">
                    <SvgIcon id={'wallet'}/>
                    {t('notifications.reload-claimed')}
                </strong>
            </div>
            <div className="toast-body">
                {Big(amount || 0).toFixed(8)} <InstrumentIcon code={code}/> {t('notifications.reload-claimed')}
            </div>
        </div>

    )

}

export default ReloadToast
